document.addEventListener('DOMContentLoaded', function () {
  const sizeMap = {
    SM: 'S',
    MD: 'M',
    LG: 'L'
  };

  const sizeSelectors = [
    '.variant-option__button-label__text',
    '.cart-items__variant dd',
    '.globo-swatch-product-detail .swatch--gl li.select-option label.globo-style--button'
  ].join(', ');

  const hiddenProductTag = 'hidden for now';
  const productRequestCache = new Map();

  /*
   * Ændrer kun den synlige størrelsestekst:
   * SM → S, MD → M, LG → L.
   */
  function replaceSizeText(element) {
    const walker = document.createTreeWalker(
      element,
      NodeFilter.SHOW_TEXT
    );

    let textNode;

    while ((textNode = walker.nextNode())) {
      const originalText = textNode.nodeValue;

      const updatedText = originalText.replace(
        /(^|[\s:])(SM|MD|LG)(?=\s*(?:-|$))/g,
        function (match, prefix, size) {
          return prefix + sizeMap[size];
        }
      );

      if (updatedText !== originalText) {
        textNode.nodeValue = updatedText;
      }
    }

    element.setAttribute('data-size-ready', 'true');
  }

  function replaceAllSizes() {
    document
      .querySelectorAll(sizeSelectors)
      .forEach(replaceSizeText);
  }

  /*
   * Tilpasser colour-overskriften.
   *
   * Eksempel:
   * Other Colors: BP Tee - Black
   * bliver til:
   * COLOUR: Black
   */
  function renameColorHeading() {
    const colorContainers = document.querySelectorAll(
      '.globo-product-groups-detail'
    );

    colorContainers.forEach(function (colorContainer) {
      const walker = document.createTreeWalker(
        colorContainer,
        NodeFilter.SHOW_TEXT
      );

      let textNode;

      while ((textNode = walker.nextNode())) {
        const originalText = textNode.nodeValue;
        let updatedText = originalText;

        const leadingWhitespaceMatch =
          originalText.match(/^\s*/);

        const trailingWhitespaceMatch =
          originalText.match(/\s*$/);

        const leadingWhitespace = leadingWhitespaceMatch
          ? leadingWhitespaceMatch[0]
          : '';

        const trailingWhitespace = trailingWhitespaceMatch
          ? trailingWhitespaceMatch[0]
          : '';

        updatedText = updatedText.replace(
          /Other Colors/gi,
          'COLOUR'
        );

        updatedText = updatedText.replace(
          /\bCOLOURS?\b/gi,
          'COLOUR'
        );

        if (updatedText.includes(' - ')) {
          let content = updatedText.trim();
          let headingPrefix = '';

          const colourHeadingMatch = content.match(
            /^COLOUR\s*:\s*/i
          );

          if (colourHeadingMatch) {
            headingPrefix = 'COLOUR: ';

            content = content
              .slice(colourHeadingMatch[0].length)
              .trim();
          } else if (content.startsWith(':')) {
            headingPrefix = ': ';

            content = content
              .slice(1)
              .trim();
          }

          const separatorIndex =
            content.indexOf(' - ');

          if (separatorIndex !== -1) {
            const colorName = content
              .slice(separatorIndex + 3)
              .trim();

            updatedText =
              leadingWhitespace +
              headingPrefix +
              colorName +
              trailingWhitespace;
          }
        }

        if (updatedText !== originalText) {
          textNode.nodeValue = updatedText;
        }

        if (
          updatedText
            .trim()
            .toUpperCase()
            .startsWith('COLOUR') &&
          textNode.parentElement
        ) {
          textNode.parentElement.style.setProperty(
            'font-size',
            '12px',
            'important'
          );

          textNode.parentElement.style.setProperty(
            'font-weight',
            '400',
            'important'
          );
        }
      }
    });
  }

  /*
   * Flytter colour-gruppen foran størrelsesvælgeren.
   */
  function moveColorsBeforeSize() {
    const sizeContainer = document.querySelector(
      '.globo-swatch-product-detail'
    );

    const colorContainer = document.querySelector(
      '.globo-product-groups-detail'
    );

    if (!sizeContainer || !colorContainer) {
      return;
    }

    let commonParent = sizeContainer.parentElement;

    while (
      commonParent &&
      !commonParent.contains(colorContainer)
    ) {
      commonParent = commonParent.parentElement;
    }

    if (
      !commonParent ||
      commonParent === document.body
    ) {
      return;
    }

    let sizeBranch = sizeContainer;

    while (
      sizeBranch.parentElement &&
      sizeBranch.parentElement !== commonParent
    ) {
      sizeBranch = sizeBranch.parentElement;
    }

    let colorBranch = colorContainer;

    while (
      colorBranch.parentElement &&
      colorBranch.parentElement !== commonParent
    ) {
      colorBranch = colorBranch.parentElement;
    }

    if (sizeBranch === colorBranch) {
      return;
    }

    if (
      colorBranch.nextElementSibling !== sizeBranch
    ) {
      commonParent.insertBefore(
        colorBranch,
        sizeBranch
      );
    }
  }

  /*
   * Henter produktdata én gang pr. produkt.
   */
  function getProductData(productUrl) {
    if (!productRequestCache.has(productUrl)) {
      const request = fetch(productUrl, {
        headers: {
          Accept: 'application/json'
        }
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error(
              'Kunne ikke hente GLO-produktet.'
            );
          }

          return response.json();
        })
        .catch(function (error) {
          /*
           * Tillad et senere forsøg, hvis forespørgslen fejler.
           */
          productRequestCache.delete(productUrl);
          throw error;
        });

      productRequestCache.set(
        productUrl,
        request
      );
    }

    return productRequestCache.get(productUrl);
  }

  /*
   * Skjuler GLO-produkter med Shopify-tagget:
   * hidden for now
   */
  function filterHiddenGloProducts() {
    const productItems = document.querySelectorAll(
      '.globo-product-groups-detail .gsw-prg-item'
    );

    productItems.forEach(function (item) {
      const link = item.querySelector(
        'a[href*="/products/"]'
      );

      if (!link) {
        return;
      }

      const url = new URL(
        link.href,
        window.location.origin
      );

      url.search = '';
      url.hash = '';

      if (!url.pathname.endsWith('.js')) {
        url.pathname =
          url.pathname.replace(/\/$/, '') + '.js';
      }

      const productUrl = url.toString();

      /*
       * Undgå gentagne kontroller af samme element.
       */
      if (
        item.dataset.hiddenTagProductUrl ===
          productUrl &&
        (
          item.dataset.hiddenTagStatus ===
            'loading' ||
          item.dataset.hiddenTagStatus ===
            'complete'
        )
      ) {
        return;
      }

      item.dataset.hiddenTagProductUrl =
        productUrl;

      item.dataset.hiddenTagStatus =
        'loading';

      getProductData(productUrl)
        .then(function (product) {
          /*
           * GLO kan have udskiftet elementet, mens
           * produktdata blev hentet.
           */
          if (
            !item.isConnected ||
            item.dataset.hiddenTagProductUrl !==
              productUrl
          ) {
            return;
          }

          const tags = Array.isArray(product.tags)
            ? product.tags
            : String(product.tags || '').split(',');

          const shouldHide = tags.some(
            function (tag) {
              return (
                String(tag)
                  .trim()
                  .toLowerCase() ===
                hiddenProductTag
              );
            }
          );

          item.hidden = shouldHide;

          if (shouldHide) {
            item.setAttribute(
              'aria-hidden',
              'true'
            );
          } else {
            item.removeAttribute(
              'aria-hidden'
            );
          }

          item.dataset.hiddenTagStatus =
            'complete';
        })
        .catch(function () {
          if (
            item.dataset.hiddenTagProductUrl ===
            productUrl
          ) {
            delete item.dataset.hiddenTagStatus;
          }
        });
    });
  }

  /*
   * Samlet GLO-opdatering.
   */
  function updateGloWidget() {
    replaceAllSizes();
    renameColorHeading();
    moveColorsBeforeSize();
    filterHiddenGloProducts();
  }

  let updateQueued = false;

  function queueGloUpdate() {
    if (updateQueued) {
      return;
    }

    updateQueued = true;

    requestAnimationFrame(function () {
      updateQueued = false;
      updateGloWidget();
    });
  }

  /*
   * Første gennemgang.
   */
  updateGloWidget();

  /*
   * GLO renderer indhold dynamisk.
   */
  const observer = new MutationObserver(
    queueGloUpdate
  );

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });

  /*
   * Fallback til langsommere mobil-rendering.
   */
  window.setTimeout(updateGloWidget, 250);
  window.setTimeout(updateGloWidget, 750);
  window.setTimeout(updateGloWidget, 1500);
  window.setTimeout(updateGloWidget, 3000);
});